import Api  from './request'

export default class TradeApi {
    static tradeExamine(form) {
        return Api.post('/api/trade/auth', form)
    }
}
